import { nativeUndefined } from './internals/native.js';
import isArrayLike from './isArrayLike.js';

var nth = function (array, n) {
    if (n === void 0) { n = 0; }
    if (!isArrayLike(array)) {
        return nativeUndefined;
    }
    n += n < 0 ? array.length : 0;
    return array[n];
};

export { nth as default };
